import { render } from "./Forum.vue?vue&type=template&id=f952c466&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"

import "./Forum.vue?vue&type=style&index=0&id=f952c466&scoped=true&lang=css"
import "./Forum.vue?vue&type=style&index=1&id=f952c466&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f952c466"]])

export default __exports__